import * as pages from './page-names';

export const homeRoute = '/' + pages.homePageName;

export const changePasswordRoute = '/' + pages.changePasswordPageName;
export const forgotPasswordRoute = '/' + pages.forgotPasswordPageName;
export const editProfileRoute = '/' + pages.editProfilePageName;
export const loginRoute = '/' + pages.loginPageName;
export const statusDashboardRoute = '/' + pages.statusDashboardPageName;
export const servicesAdministrationRoute = '/' + pages.servicesAdministrationPageName;
export const incidentsAdministrationRoute = '/' + pages.incidentsAdministrationPageName;
export const popupsAdministrationRoute = '/' + pages.popupsAdministrationPageName;
export const serviceClientsAdministrationRoute = '/' + pages.serviceClientsAdministrationPageName;

